import React, { useState, useCallback, createContext, useContext } from "react";

const CategoryContext = createContext();

const DEFAULT_CATEGORY = {
  id: "DEFAULT_CATEGORY",
  name: "See all",
  slug: null,
};

function CategoryProvider({ children }) {
  const [category, setCategory] = useState(DEFAULT_CATEGORY.id);

  const isSelectedCategory = useCallback(
    (newCategory) => {
      return category == newCategory.id;
    },
    [category]
  );

  const setSelectedCategory = (newCategory) => setCategory(newCategory.id);

  const filterPostsByCategory = useCallback(
    (posts) => {
      if (isSelectedCategory(DEFAULT_CATEGORY)) {
        return posts;
      }

      return posts.filter((post) => post.categories.find((c) => isSelectedCategory(c)));
    },
    [category]
  );

  const value = {
    isSelectedCategory,
    setSelectedCategory,
    filterPostsByCategory,
    defaultCategory: DEFAULT_CATEGORY,
  };

  return <CategoryContext.Provider value={value}>{children}</CategoryContext.Provider>;
}

function useCategory() {
  const context = useContext(CategoryContext);

  if (context === undefined) {
    throw new Error("useCategory must be used within a CategoryProvider");
  }

  return context;
}

export { CategoryProvider, useCategory };
